import { cilHome, cilMenu } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler
} from '@coreui/react-pro'
import { useLocation } from 'react-router-dom'
import { NavButtonAvatar } from '../..'
import { useUIStore } from '../../../../core/store'
import { NavButtonNotification } from '../icons-nav/nav-button-notification/NavButtonNotification'
import { NavButtonLocale } from '../icons-nav/nav-button-locale/NavButtonLocale'




const getRouteObject = (path: string) => {
  switch (true) {
    case /^\/dashboard\/compania\/\d+\/detalle$/.test(path):
      return {
        component: () => <div>Detalle empresa</div>,
        name: 'Detalle empresa',
        icon: <CIcon icon={cilHome} />, // Puedes cambiar el icono según lo necesites
        to: path,
      };
    case /^\/dashboard\/compania\/\d+\/documentos$/.test(path):
      return {
        component: () => <div>Documentos de la empresa</div>,
        name: 'Documentos de la empresa',
        icon: <CIcon icon={cilHome} size='lg' />, // Cambia el icono según lo necesites
        to: path,
      };
    case /^\/dashboard\/home$/.test(path):
      return {
        component: () => <div>Dashboard</div>,
        name: 'Dashboard',
        icon: <CIcon icon={cilHome} size='lg' />,
        to: path,
      };
    case /^\/dashboard\/compania\/\d+\/facturacion$/.test(path):
      return {
        component: () => <div>Facturación</div>,
        name: 'Facturación',
        icon: <CIcon icon={cilHome} size='lg' />,
        to: path,
      };
    default:
      return null;
  }
};


const AppHeader = (): JSX.Element => {

  const location = useLocation();

  const { sidebarShow, asideShow, setUI } = useUIStore(state => state)


  // useEffect(() => {
  // }, [location])


  const routeObject = getRouteObject(location.pathname);

  return (
    // <CHeader position="sticky" className="mb-4">
    <CHeader position="sticky" className="cHeaderWithColor">

      <CContainer fluid>
        <CHeaderToggler
          style={{ color: "black" }}
          className="ps-1"

          onClick={() => {
            setUI({ sidebarShow: !sidebarShow })
            // dispatch({ type: 'set', sidebarShow: !sidebarShow })
          }}
        >
          <CIcon icon={cilMenu} size="lg" style={{ color: "black" }} />
        </CHeaderToggler>

        <CHeaderBrand className="mx-auto d-md-none" >
          {/* Aquí podría ir un logo también */}
          {/* <CIcon icon={logo} height={48} /> */}
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto" >
          {/* <CNavItem >
            <CNavLink to="/dashboard" component={NavLink} style={{ color: "white" }}>
              Dashboard
            </CNavLink>
          </CNavItem> */}

          {routeObject && (
            <>
              {routeObject.name && <div style={{ fontFamily: "Roboto", fontSize: 18, fontWeight: 500, color: "black" }}>{routeObject.name}</div>}
              {/* {routeObject.icon && <div style={{ marginLeft: 5 }}>{routeObject.icon}</div>} */}

              {/* {routeObject.component()} */}
            </>
          )}

        </CHeaderNav>
        {/* <div className="md:px-0 ">
          <NavButtonNotification />
        </div>
        <div className="flex items-center mr-3">
          <div className="border-l border-gray-300 h-6"></div>
        </div>
        <div className="md:px-0 mr-5">
          <NavButtonLocale />
        </div>
        <div className="md:px-0 md:mr-3">
          <NavButtonAvatar />
        </div> */}

        {/* <CHeaderToggler
          className="px-md-0 me-md-3"
          onClick={() => {
            setUI({ asideShow: !asideShow })
          }}
        >
          <CIcon icon={cilApplicationsSettings} size="lg" />
        </CHeaderToggler> */}
      </CContainer>
      {/* <CHeaderDivider />
      <CContainer fluid>
        <AppBreadcrumb />
      </CContainer> */}
    </CHeader>
  )
}

export default AppHeader
